<div class="locationContainer">

    <img
        class="locationImage"
        [src]="location.img | safeHtml"
        *ngIf="location.img != null"
    />
    <h2 class="locationName">{{ location.name }}</h2>
</div>
<div class="screenContainer" *ngFor="let face of location.faces">
    <mat-card appearance="outlined" class="screenItem">
        <div class="screenInfos">
            <img src="{{ baseUrl }}/File/getFile/{{ face.file?.thumbnailStorageId }}/{{face.file?.fileName}}" *ngIf="face.file?.id !== null"/>
            <p class="screenName">
                {{ face.name }}
                <br/>
                <span class="screenDescription">{{ face.desc != null ? (face.desc | slice: 0:50) : '' }}</span>
                <!-- <span class="material-icons screenInfoIcon" (click)="openDetail(face.id)">info</span> -->
            </p>
            <mat-icon matTooltip="Signaler un problème" *ngIf="face.canCreateTicket" class="reportProblem" (click)="reportProblem(face.id)">report_problem</mat-icon>
        </div>

        <div
            class="screenCampaignList"
            cdkDropList 
            [cdkDropListData]="face.actualDiffs"
            (cdkDropListDropped)="drop($event, face)"
            >
            <div
            *ngIf="(this.userService.isAllowed('CreateCampaignOnPersonalScreen','CanCreateCampaignOnScreen') || this.userService.isAllowed('CreateCampaignOnWancomDiffuseurScreen', 'CanCreateCampaignOnAllScreens') )&& face.canCreateCampaign"
                class="CampaignItem AddCampaign" (click)="addCampaign(face.id)">
                <div class="addIcon addIconContainer">
                    <i class="material-icons addIcon">add</i>
                </div>
                <p class="spotName newCampaign">Ajouter une campagne</p>
            </div>

            <div class="DefaultCampaignContainer"
                     *ngFor="let diff of face.actualDiffs"
                     cdkDrag [cdkDragStartDelay]="isDesktopDevice ? 0:100" [cdkDragDisabled]="!face.canEditCampaign">
                <div *ngIf="diff.fill == 4" [ngClass]="diff.isDisabled ? 'CampaignItem defaultCampaign disabledCampaign' : 'CampaignItem defaultCampaign'">
                    <div class="imgContainer">
                        <img
                            (click)="playSpot(diff.spotId, diff.file?.id)"
                            src="{{ baseUrl }}/file/getFile/{{ diff.file?.thumbnailStorageId }}/{{diff.file?.fileName}}"
                            *ngIf="diff.file?.thumbnailStorageId != null && diff.isComputing"
                            onerror="this.src ='https://wancomresource.s3.eu-west-3.amazonaws.com/camera.svg'"
                            [alt]="diff.file?.fileName"
                        />
                        <img
                            (click)="playSpot(diff.spotId,diff.file?.id )"
                            src="{{ baseUrl }}/file/getFile/{{ diff.file?.thumbnailStorageId }}/{{diff.file?.fileName}}"
                            *ngIf="(diff.generationStatus == null || diff.generationStatus == 0) && diff.file?.thumbnailStorageId != null && !diff.isComputing"
                            onerror="this.src ='https://wancomresource.s3.eu-west-3.amazonaws.com/camera.svg'"
                            [alt]="diff.file?.fileName"
                        />
                        <span *ngIf="(diff.generationStatus == null || diff.generationStatus == 0) && diff.file?.thumbnailStorageId == null" class="material-icons processingBigIcon">design_services</span>

                        <div>
                            <img *ngIf="diff.generationStatus == 20" class="processingIcon"
                                    src="../../../../assets/settingcustomslow.gif" alt="processing"> 
                            <span *ngIf="diff.generationStatus == 20" class="progression processingTxt">{{diff.progression}}</span>
                        </div>
                        <span *ngIf="diff.generationStatus == 10" class="material-icons processingBigIcon">schedule</span>
                        <span *ngIf="diff.generationStatus == 100" class="material-icons processingBigIcon">error_outline</span>
                    </div>
                    <p class="spotName">
                        {{ diff.name }}
                        <span class="processingTxt" *ngIf="(diff.generationStatus == null || diff.generationStatus == 0) && diff.file?.thumbnailStorageId == null">En cours de création</span>
                        <span class="processingTxt" *ngIf="diff.generationStatus == 10">En attente de traitement</span>
                        <span class="processingTxt" *ngIf="diff.generationStatus == 20">En cours de traitement</span>
                        <span class="processingTxt" *ngIf="diff.generationStatus == 100">Erreur de traitement</span>
                        <span class="defaultDuration">Campagne par défaut</span>
                    </p>
                    <mat-icon *ngIf="diff.isProtected" class="material-icons shieldIcon" matTooltip="Spot protégé">shield</mat-icon>
                    <mat-icon *ngIf="!diff.canModify" matTooltip="Spot non modifiable" class="lockIcon">lock</mat-icon>
                    <button *ngIf="diff.canModify && !diff.isDisabled" class="matMenuButton" mat-icon-button [matMenuTriggerFor]="menu">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item (click)="editCampaignSpot(diff.id, diff.isProtected, duplicationcampaigntemplate, face.id)">
                            <mat-icon>play_circle_outline</mat-icon>
                            <span>Changer de spot</span>
                        </button>
                    </mat-menu>
                </div>
                <div class="CampaignItem " *ngIf="diff.fill != 4" [ngClass]="diff.isDisabled ? 'CampaignItem  disabledCampaign' : 'CampaignItem '">
                    <div class="imgContainer" >
                        <img
                            (click)="playSpot(diff.spotId,diff.file?.id )"
                            src="{{ baseUrl }}/file/getFile/{{ diff.file?.thumbnailStorageId }}/{{diff.file?.fileName}}"
                            *ngIf="diff.file?.thumbnailStorageId != null && !diff.isComputing"
                            onerror="this.src ='https://wancomresource.s3.eu-west-3.amazonaws.com/camera.svg'"
                        />
                        <img
                            (click)="playSpot(diff.spotId, diff.file?.id )"
                            src="{{ baseUrl }}/file/getFile/{{ diff.file?.thumbnailStorageId }}/{{diff.file?.fileName}}"
                            *ngIf="(diff.generationStatus == null || diff.generationStatus == 0) && diff.file?.thumbnailStorageId != null && diff.isComputing"
                            onerror="this.src ='https://wancomresource.s3.eu-west-3.amazonaws.com/camera.svg'"
                        />
                        <span *ngIf="(diff.generationStatus == null || diff.generationStatus == 0) && diff.file?.thumbnailStorageId == null" class="material-icons processingBigIcon">design_services</span>
                        <div>
                            <img *ngIf="diff.generationStatus == 20" class="processingIcon"
                                    src="../../../../assets/settingcustomslow.gif"> 
                            <span *ngIf="diff.generationStatus == 20" class="progression processingTxt">{{diff.progression}}</span>
                        </div>
                        <span *ngIf="diff.generationStatus == 10" class="material-icons processingBigIcon">schedule</span>
                        <span *ngIf="diff.generationStatus == 100" class="material-icons processingBigIcon">error_outline</span>
                        <!-- <mat-icon *ngIf="diff.thumbnailId == null"  class="processingIcon" svgIcon="videoProcessing"></mat-icon> -->
                    </div>
                    <p class="spotName">
                        {{ diff.name }}
                        <span class="processingTxt" *ngIf="(diff.generationStatus == null || diff.generationStatus == 0) && diff.file?.thumbnailStorageId == null">En cours de création</span>
                        <span class="processingTxt" *ngIf="diff.generationStatus == 20">En cours de traitement</span>
                        <span class="processingTxt" *ngIf="diff.generationStatus == 10">En attente de traitement</span>
                        <span class="processingTxt" *ngIf="diff.generationStatus == 100">Erreur de traitement</span>
                        <span class="duration" *ngIf="diff.nbDays != 0 && diff.nbDays != 1 && diff.generationStatus != 20 && diff.generationStatus != 100">
                            Encore {{ diff.nbDays }} jours<span class="otherScreen" *ngIf="diff.otherScreens != 0">+ {{ diff.otherScreens }} écran<span *ngIf="diff.otherScreens != 1">s</span>
                        </span>
                        </span>
                        <span class="duration" *ngIf="diff.nbDays == 0 && diff.generationStatus != 20 && diff.generationStatus != 100">
                            Jusqu'à ce soir<span class="otherScreen" *ngIf="diff.otherScreens != 0 ">+ {{ diff.otherScreens }} écran<span *ngIf="diff.otherScreens != 1">s</span></span>
                        </span>
                        <span class="duration" *ngIf="diff.nbDays == 1 && diff.generationStatus != 20 && diff.generationStatus != 100">
                            Jusqu'à demain<span class="otherScreen" *ngIf="diff.otherScreens != 0 ">+ {{ diff.otherScreens }} écran<span *ngIf="diff.otherScreens != 1">s</span></span>
                        </span>

                        <span class="littleDetail" *ngIf="diff.dayString != null && diff.dayString != ''">{{
                            diff.dayString
                            }}</span>
                        <span class="littleDetail" *ngIf="diff.minTemp != null && diff.maxTemp != null"
                        >{{ diff.minTemp }}°-{{ diff.maxTemp }}°</span>
                        <span class="littleDetail" *ngIf="diff.beginHour != null && diff.endHour != null"
                        >{{ diff.beginHour }}h-{{ diff.endHour }}h</span>
                        <span class="littleDetail" *ngIf="diff.weather != null">{{ weatherParams[diff.weather] }}</span>

                        <!--								TODO : gerer les différents droits-->
                        <!--								<span *ngIf="diff.canModify">M</span>-->
                        <!--								<span *ngIf="diff.isProtected">P</span>-->
                        <!--								<span *ngIf="diff.isLocked">L</span>-->
                    </p>
                    <mat-icon *ngIf="diff.isProtected" class="material-icons shieldIcon" matTooltip="Spot protégé">shield</mat-icon>
                    <mat-icon *ngIf="!diff.canModify" matTooltip="Spot non modifiable" class="lockIcon">lock</mat-icon>
                    <button *ngIf="diff.canModify && !diff.isDisabled" mat-icon-button class="matMenuButton" [matMenuTriggerFor]="menu">
                        <mat-icon>more_vert</mat-icon>
                    </button>

                    <mat-menu #menu="matMenu">
                        <button mat-menu-item  (click)="editCampaignParams(diff.id, diff.isProtected, duplicationcampaigntemplate, face.id, diff.spotId)">
                            <!--[routerLink]="campaign.id"> -->
                            <mat-icon>edit</mat-icon>
                            <span>Modifier les paramètres de diffusion</span>
                        </button>
                        <button mat-menu-item *ngIf="!diff.isProtected" (click)="editCampaignScreens(diff.id, diff.spotId, diff.isProtected, duplicationcampaigntemplate, face.id)">
                            <mat-icon>tv</mat-icon>
                            <span>Modifier les écrans</span>
                        </button>
                        <button mat-menu-item (click)="editCampaignSpot(diff.id, diff.isProtected, duplicationcampaigntemplate, face.id)">
                            <mat-icon>play_circle_outline</mat-icon>
                            <span>Changer de spot</span>
                        </button>

                        <button
                            mat-menu-item
                            *ngIf="diff.fill == 6 && diff.templateRefId != null && (userService.isAllowed('CreateSpot' , 'CanCreateSpot') || userService.hasRight('CanEditSpotNotOwned'))"
                            (click)="editCurrentCampaignSpot(diff.id, diff.templateRefId, diff.spotId, diff.isProtected, duplicationcampaigntemplate, face.id)"
                        >
                            <mat-icon class="icon" svgIcon="editSpotTemplate"></mat-icon>
                            <span>Modifier le spot</span>
                        </button>

                        <button class="delete-btn" mat-menu-item (click)="dialogDeleteCampaign(deleteconfirmationtemplate, diff.isProtected, deletecampaigntemplate, face.id, diff.id)">
                            <mat-icon>cancel</mat-icon>
                            <span *ngIf="!diff.isProtected">Supprimer la campagne</span>
                            <span *ngIf="diff.isProtected">Désactiver la campagne</span>
                        </button>
                    </mat-menu>
                </div>
                <ng-template #duplicationcampaigntemplate>
                    <mat-dialog-content class="mat-typography duplicateDialog">
                        <mat-icon  class="material-icons shieldDialogIcon" matTooltip="Spot protégé">shield</mat-icon>
                        <div style="display: inline-block; vertical-align: top;">
                            <h2 mat-dialog-title>
                                Campagne protégée
                            </h2>
                            <p >
                                La campagne que vous souhaitez modifier est protégée. <br/>
                                Pour continuer, la campagne sera dupliquée et l'ancienne ne diffusera plus sur cet écran.
                            </p>
                        </div>
                            
                    </mat-dialog-content>
                    <mat-dialog-actions align="end">
                        <button mat-raised-button [mat-dialog-close]="false" cdkFocusInitial>Annuler</button>
                        <button
                            mat-raised-button
                            color="secondary"
                            [mat-dialog-close]="true"
                        >
                            Dupliquer
                        </button>
                    </mat-dialog-actions>
                </ng-template>
                <ng-template #deletecampaigntemplate>
                    <mat-dialog-content class="mat-typography duplicateDialog">
                        <mat-icon  class="material-icons shieldDialogIcon" matTooltip="Spot protégé">shield</mat-icon>
                        <div style="display: inline-block; vertical-align: top;">
                            <h2 mat-dialog-title>
                                Campagne protégée
                            </h2>
                            <p>
                                La campagne que vous souhaitez supprimer est protégée.<br/>
                                Nous pouvons désactiver la campagne sur cet écran.
                            </p>
                        </div>	
                    </mat-dialog-content>
                    <mat-dialog-actions align="end">
                        <button mat-raised-button [mat-dialog-close]="false" cdkFocusInitial>Annuler</button>
                        <button
                            mat-raised-button
                            color="secondary"
                            [mat-dialog-close]="true"
                        >
                            Désactiver
                        </button>
                    </mat-dialog-actions>
                </ng-template>
                <ng-template #deleteconfirmationtemplate>
                    <mat-dialog-content class="mat-typography deleteDialog">
                        <h2 mat-dialog-title>
                            Suppression
                        </h2>
                
                        {{diff.otherScreen}}
                        <p *ngIf="diff.otherScreens == 0">
                            Êtes-vous sûr(e) de vouloir supprimer cette campagne ?
                        </p>
                        <p *ngIf="diff.otherScreens !== 0">
                            Cette campagne diffuse également sur d'autres écrans, que souhaitez-vous faire ?
                        </p>
                    </mat-dialog-content>
                    <mat-dialog-actions align="end">
                        <button mat-raised-button [mat-dialog-close]="true" cdkFocusInitial>Annuler</button>
                        <button
                            mat-raised-button
                            color="secondary"
                            [mat-dialog-close]="true"
                            *ngIf="diff.otherScreens == 0"
                            (click)="removeCampaign(diff.id)"
                        >
                            Supprimer
                        </button>
                        <button
                            mat-raised-button
                            color="secondary"
                            [mat-dialog-close]="true"
                            *ngIf="diff.otherScreens != 0"
                            (click)="removeFaceFromCampaign(diff.id, face.id)"
                        >
                            Supprimer uniquement pour cet écran
                        </button>
                        <button
                            mat-raised-button
                            [mat-dialog-close]="true"
                            *ngIf="diff.otherScreens != 0"
                            (click)="removeCampaign(diff.id)"
                        >
                            Supprimer pour tous les écrans
                        </button>
                    </mat-dialog-actions>
                </ng-template>

            </div>
            
            <div *ngIf="face.seeFutureDiff" class="futuresDiffs">
                <div class="DefaultCampaignContainer" *ngFor="let diff of face.futuresDiffs">
                    <div *ngIf="diff.fill == 4" [ngClass]="diff.isDisabled ? 'CampaignItem defaultCampaign disabledCampaign' : 'CampaignItem '">
                        
                        <div class="imgContainer">
                            <img
                                (click)="playSpot(diff.spotId ,diff.file?.id)"
                                src="{{ baseUrl }}/file/getFile/{{ diff.file?.thumbnailStorageId }}/{{diff.file?.fileName}}"
                                *ngIf="diff.file?.thumbnailStorageId != null && !diff.isComputing"
                                onerror="this.src ='https://wancomresource.s3.eu-west-3.amazonaws.com/camera.svg'"
                            />
                            <img
                                (click)="playSpot(diff.spotId, diff.file?.id )"
                                src="{{ baseUrl }}/file/getFile/{{ diff.file?.thumbnailStorageId }}/{{diff.file?.fileName}}"
                                *ngIf="(diff.generationStatus == null || diff.generationStatus == 0) && diff.file?.thumbnailStorageId != null && diff.isComputing"
                                onerror="this.src ='https://wancomresource.s3.eu-west-3.amazonaws.com/camera.svg'"
                            />
                            <span *ngIf="(diff.generationStatus == null || diff.generationStatus == 0) && diff.file?.thumbnailStorageId == null" class="material-icons processingBigIcon">design_services</span>
                            <div>
                                <img *ngIf="diff.generationStatus == 20" class="processingIcon"
                                        src="../../../../assets/settingcustomslow.gif">
                                <span *ngIf="diff.generationStatus == 20" class="progression processingTxt">{{diff.progression}}</span>
                            </div>
                            <span *ngIf="diff.generationStatus == 10" class="material-icons processingBigIcon">schedule</span>
                            <span *ngIf="diff.generationStatus == 100" class="material-icons processingBigIcon">error_outline</span>
                            <!-- <mat-icon *ngIf="diff.thumbnailId == null"  class="processingIcon" svgIcon="videoProcessing"></mat-icon> -->
                        </div>
                        <p class="spotName">
                            {{ diff.name }}
                            <span class="processingTxt" *ngIf="(diff.generationStatus == null || diff.generationStatus == 0) && diff.file?.thumbnailStorageId == null">En cours de création</span>
                            <span class="processingTxt" *ngIf="diff.generationStatus == 20">En cours de traitement</span>
                            <span class="processingTxt" *ngIf="diff.generationStatus == 10">En attente de traitement</span>
                            <span class="processingTxt" *ngIf="diff.generationStatus == 100">Erreur de traitement</span>
                            <span class="defaultDuration">Campagne par défaut</span>
                        </p>
                        <mat-icon *ngIf="diff.isProtected" class="material-icons shieldIcon" matTooltip="Spot protégé">shield</mat-icon>
                        <mat-icon *ngIf="!diff.canModify" matTooltip="Spot non modifiable" class="lockIcon">lock</mat-icon>
                        <button *ngIf="diff.canModify && !diff.isDisabled" class="matMenuButton" mat-icon-button [matMenuTriggerFor]="menu">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="editCampaignSpot(diff.id, diff.isProtected, duplicationcampaigntemplate , face.id)">
                                <mat-icon>play_circle_outline</mat-icon>
                                <span>Changer de spot</span>
                            </button>
                        </mat-menu>
                        <ng-template #duplicationcampaigntemplate>
                            <mat-dialog-content class="mat-typography duplicateDialog">
                                <mat-icon  class="material-icons shieldDialogIcon" matTooltip="Spot protégé">shield</mat-icon>
                                <div style="display: inline-block; vertical-align: top;">
                                    <h2 mat-dialog-title>
                                        Campagne protégée
                                    </h2>
                                    <p >
                                        La campagne que vous souhaitez modifier est protégée. <br/>
                                        Pour continuer, la campagne sera dupliquer et l'ancienne ne diffusera plus sur cet écran.
                                    </p>
                                </div>
                                    
                            </mat-dialog-content>
                            <mat-dialog-actions align="end">
                                <button mat-raised-button [mat-dialog-close]="false" cdkFocusInitial>Annuler</button>
                                <button
                                    mat-raised-button
                                    color="secondary"
                                    [mat-dialog-close]="true"
                                >
                                    Dupliquer
                                </button>
                            </mat-dialog-actions>
                        </ng-template>
                        
                        
                    </div>
                    <ng-template #duplicationcampaigntemplate>
                        <mat-dialog-content class="mat-typography duplicateDialog">
                            <mat-icon  class="material-icons shieldDialogIcon" matTooltip="Spot protégé">shield</mat-icon>
                            <div style="display: inline-block; vertical-align: top;">
                                <h2 mat-dialog-title>
                                    Campagne protégée
                                </h2>
                                <p >
                                    La campagne que vous souhaitez modifier est protégée. <br/>
                                    Pour continuer, la campagne sera dupliquée et l'ancienne ne diffusera plus sur cet écran.
                                </p>
                            </div>
                                
                        </mat-dialog-content>
                        <mat-dialog-actions align="end">
                            <button mat-raised-button [mat-dialog-close]="false" cdkFocusInitial>Annuler</button>
                            <button
                                mat-raised-button
                                color="secondary"
                                [mat-dialog-close]="true"
                            >
                                Dupliquer
                            </button>
                        </mat-dialog-actions>
                    </ng-template>
                    <ng-template #deletecampaigntemplate>
                        <mat-dialog-content class="mat-typography duplicateDialog">
                            <mat-icon  class="material-icons shieldDialogIcon" matTooltip="Spot protégé">shield</mat-icon>
                            <div style="display: inline-block; vertical-align: top;">
                                <h2 mat-dialog-title>
                                    Campagne protégée
                                </h2>
                                <p>
                                    La campagne que vous souhaitez supprimer est protégée.<br/>
                                    Nous pouvons désactiver la campagne sur cet écran.
                                </p>
                            </div>	
                        </mat-dialog-content>
                        <mat-dialog-actions align="end">
                            <button mat-raised-button [mat-dialog-close]="false" cdkFocusInitial>Annuler</button>
                            <button
                                mat-raised-button
                                color="secondary"
                                [mat-dialog-close]="true"
                            >
                                Désactiver
                            </button>
                        </mat-dialog-actions>
                    </ng-template>
                    <ng-template #deleteconfirmationtemplate>
                        <mat-dialog-content class="mat-typography deleteDialog">
                            <h2 mat-dialog-title>
                                Suppression
                            </h2>
                    
                            {{diff.otherScreen}}
                            <p *ngIf="diff.otherScreens == 0">
                                Êtes-vous sûr(e) de vouloir supprimer cette campagne ?
                            </p>
                            <p *ngIf="diff.otherScreens !== 0">
                                Cette campagne diffuse également sur d'autres écrans, que souhaitez-vous faire ?
                            </p>
                        </mat-dialog-content>
                        <mat-dialog-actions align="end">
                            <button mat-raised-button [mat-dialog-close]="true" cdkFocusInitial>Annuler</button>
                            <button
                                mat-raised-button
                                color="secondary"
                                [mat-dialog-close]="true"
                                *ngIf="diff.otherScreens == 0"
                                (click)="removeCampaign(diff.id)"
                            >
                                Supprimer
                            </button>
                            <button
                                mat-raised-button
                                color="secondary"
                                [mat-dialog-close]="true"
                                *ngIf="diff.otherScreens != 0"
                                (click)="removeFaceFromCampaign(diff.id, face.id)"
                            >
                                Supprimer uniquement pour cet écran
                            </button>
                            <button
                                mat-raised-button
                                [mat-dialog-close]="true"
                                *ngIf="diff.otherScreens != 0"
                                (click)="removeCampaign(diff.id)"
                            >
                                Supprimer pour tous les écrans
                            </button>
                        </mat-dialog-actions>
                    </ng-template>
                    
                </div>
                <div class="DefaultCampaignContainer" *ngFor="let diff of face.futuresDiffs">
                    <div class="CampaignItem" *ngIf="diff.fill != 4">
                        <div class="imgContainer">
                            <img
                                (click)="playSpot(diff.spotId, diff.file?.id )"
                                src="{{ baseUrl }}/file/getFile/{{ diff.file?.thumbnailStorageId }}/{{diff.file?.fileName}}"
                                *ngIf="diff.file?.thumbnailStorageId != null"
                                onerror="this.src ='https://wancomresource.s3.eu-west-3.amazonaws.com/camera.svg'"
                            />
                            <div>
                                <img *ngIf="diff.generationStatus == 20" class="processingIcon"
                                        src="../../../../assets/settingcustomslow.gif">
                                <span *ngIf="diff.generationStatus == 20" class="progression processingTxt">{{diff.progression}}</span>
                            </div>
                            <img
                                (click)="playSpot(diff.spotId, diff.file?.id )"
                                src="{{ baseUrl }}/file/getFile/{{ diff.file?.thumbnailStorageId }}/{{diff.file?.fileName}}"
                                *ngIf="(diff.generationStatus == null || diff.generationStatus == 0) && diff.file?.thumbnailStorageId != null && diff.isComputing"
                                onerror="this.src ='https://wancomresource.s3.eu-west-3.amazonaws.com/camera.svg'"
                            />

                            <span *ngIf="(diff.generationStatus == null || diff.generationStatus == 0) && diff.file?.thumbnailStorageId == null" class="material-icons processingBigIcon">design_services</span>

                            <span *ngIf="diff.generationStatus == 10" class="material-icons processingBigIcon">schedule</span>
                            <span *ngIf="diff.generationStatus == 100" class="material-icons processingBigIcon">error_outline</span>
                            <!-- <mat-icon *ngIf="diff.thumbnailId == null"  class="processingIcon" svgIcon="videoProcessing"></mat-icon> -->
                        </div>
                        <p class="spotName">
                            {{ diff.name }}
                            <span class="processingTxt" *ngIf="(diff.generationStatus == null || diff.generationStatus == 0) && diff.file?.thumbnailStorageId == null">En cours de création</span>
                            <span class="processingTxt" *ngIf="diff.generationStatus == 20">En cours de traitement</span>
                            <span class="processingTxt" *ngIf="diff.generationStatus == 10">En attente de traitement</span>
                            <span class="processingTxt" *ngIf="diff.generationStatus == 100">Erreur de traitement</span>
                            <span class="duration" *ngIf="diff.nbDays == 1 || diff.nbDays == 0"
                            >Commence demain<span class="otherScreen" *ngIf="diff.otherScreens != 0"
                            >+ {{ diff.otherScreens }} écran<span *ngIf="diff.otherScreens != 1">s</span></span
                            >
                        </span>
                            <span class="duration" *ngIf="diff.nbDays != 1 && diff.nbDays != 0"
                            >Commence dans {{ diff.nbDays }} jours<span class="otherScreen" *ngIf="diff.otherScreens != 0"
                            >+ {{ diff.otherScreens }} écran<span *ngIf="diff.otherScreens != 1">s</span></span
                            >
                        </span>
                            <span class="littleDetail" *ngIf="diff.dayString != null && diff.dayString != ''">{{
                                diff.dayString
                                }}</span>
                            <span class="littleDetail" *ngIf="diff.minTemp != null && diff.maxTemp != null"
                            >{{ diff.minTemp }}°-{{ diff.maxTemp }}°</span
                            >
                            <span class="littleDetail" *ngIf="diff.beginHour != null && diff.endHour != null"
                            >{{ diff.beginHour }}h-{{ diff.endHour }}h</span
                            >
                            <span class="littleDetail" *ngIf="diff.weather != null">{{ weatherParams[diff.weather] }}</span>
                        </p>
                        <mat-icon *ngIf="diff.isProtected" class="material-icons shieldIcon" matTooltip="Spot protégé">shield</mat-icon>

                        <mat-icon *ngIf="!diff.canModify" matTooltip="Spot non modifiable" class="lockIcon">lock</mat-icon>
                        <!-- <button *ngIf="campaign.fillType == 6" class="matMenuButton" mat-icon-button [matMenuTriggerFor]="menu"> -->
                        <button *ngIf="diff.canModify && !diff.isDisabled" class="matMenuButton" mat-icon-button [matMenuTriggerFor]="menu">
                            <mat-icon>more_vert</mat-icon>
                        </button>

                        <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="editCampaignParams(diff.id, diff.isProtected, duplicationcampaigntemplate, face.id, diff.spotId)">
                                <!--[routerLink]="campaign.id"> -->
                                <mat-icon>edit</mat-icon>
                                <span>Modifier les paramètres de diffusion</span>
                            </button>
                            <button mat-menu-item *ngIf="!diff.isProtected" (click)="editCampaignScreens(diff.id, diff.spotId, diff.isProtected, duplicationcampaigntemplate, face.id)">
                                <mat-icon>tv</mat-icon>
                                <span>Modifier les écrans</span>
                            </button>
                            <button mat-menu-item (click)="editCampaignSpot(diff.id, diff.isProtected, duplicationcampaigntemplate, face.id)">
                                <mat-icon>play_circle_outline</mat-icon>
                                <span>Changer de spot</span>
                            </button>

                            <button
                                mat-menu-item
                                *ngIf="diff.fill == 6 && diff.templateRefId != null && (userService.isAllowed('CreateSpot' , 'CanCreateSpot') || userService.hasRight('CanEditSpotNotOwned'))"
                                (click)="editCurrentCampaignSpot(diff.id, diff.templateRefId, diff.spotId, diff.isProtected, duplicationcampaigntemplate, face.id)"
                            >
                                <mat-icon class="icon" svgIcon="editSpotTemplate"></mat-icon>
                                <span>Modifier le spot</span>
                            </button>

                            <button class="delete-btn" mat-menu-item (click)="dialogDeleteCampaign(deleteconfirmationtemplate, diff.isProtected, deletecampaigntemplate, diff.id)">
                                <mat-icon>cancel</mat-icon>
                                <span *ngIf="!diff.isProtected">Supprimer la campagne</span>
                                <span *ngIf="diff.isProtected">Désactiver la campagne</span>
                            </button>
                        </mat-menu>
                    </div>
                    <ng-template #duplicationcampaigntemplate>
                        <mat-dialog-content class="mat-typography duplicateDialog">
                            <mat-icon  class="material-icons shieldDialogIcon" matTooltip="Spot protégé">shield</mat-icon>
                            <div style="display: inline-block; vertical-align: top;">
                                <h2 mat-dialog-title>
                                    Campagne protégée
                                </h2>
                                <p >
                                    La campagne que vous souhaitez modifier est protégée. <br/>
                                    Pour continuer, la campagne sera dupliquée et l'ancienne ne diffusera plus sur cet écran.
                                </p>
                            </div>
                                
                        </mat-dialog-content>
                        <mat-dialog-actions align="end">
                            <button mat-raised-button [mat-dialog-close]="false" cdkFocusInitial>Annuler</button>
                            <button
                                mat-raised-button
                                color="secondary"
                                [mat-dialog-close]="true"
                            >
                                Dupliquer
                            </button>
                        </mat-dialog-actions>
                    </ng-template>
                    <ng-template #deletecampaigntemplate>
                        <mat-dialog-content class="mat-typography duplicateDialog">
                            <mat-icon  class="material-icons shieldDialogIcon" matTooltip="Spot protégé">shield</mat-icon>
                            <div style="display: inline-block; vertical-align: top;">
                                <h2 mat-dialog-title>
                                    Campagne protégée
                                </h2>
                                <p>
                                    La campagne que vous souhaitez supprimer est protégée.<br/>
                                    Nous pouvons désactiver la campagne sur cet écran.
                                </p>
                            </div>	
                        </mat-dialog-content>
                        <mat-dialog-actions align="end">
                            <button mat-raised-button [mat-dialog-close]="false" cdkFocusInitial>Annuler</button>
                            <button
                                mat-raised-button
                                color="secondary"
                                [mat-dialog-close]="true"
                            >
                                Désactiver
                            </button>
                        </mat-dialog-actions>
                    </ng-template>
                    <ng-template #deleteconfirmationtemplate>
                        <mat-dialog-content class="mat-typography deleteDialog">
                            <h2 mat-dialog-title>
                                Suppression
                            </h2>
                    
                            
                            <p *ngIf="diff.otherScreens == 0">
                                Êtes-vous sûr(e) de vouloir supprimer cette campagne ?
                            </p>
                            <p *ngIf="diff.otherScreens !== 0">
                                Cette campagne diffuse également sur d'autres écrans, que souhaitez-vous faire ?
                            </p>
                        </mat-dialog-content>
                        <mat-dialog-actions align="end">
                            <button mat-raised-button [mat-dialog-close]="true" cdkFocusInitial>Annuler</button>
                            <button
                                mat-raised-button
                                color="secondary"
                                [mat-dialog-close]="true"
                                *ngIf="diff.otherScreens == 0"
                                (click)="removeCampaign(diff.id)"
                            >
                                Supprimer
                            </button>
                            <button
                                mat-raised-button
                                color="secondary"
                                [mat-dialog-close]="true"
                                *ngIf="diff.otherScreens != 0"
                                (click)="removeFaceFromCampaign(diff.id, face.id)"
                            >
                                Supprimer uniquement pour cet écran
                            </button>
                            <button
                                mat-raised-button
                                [mat-dialog-close]="true"
                                *ngIf="diff.otherScreens != 0"
                                (click)="removeCampaign(diff.id)"
                            >
                                Supprimer pour tous les écrans
                            </button>
                        </mat-dialog-actions>
                    </ng-template>
                    
                </div>
            </div>
            <button
                mat-button
                *ngIf="!face.seeFutureDiff && face.futureDiffCount != null && face.futureDiffCount != 0"
                class="futureDiffButton"
                (click)="seeFutureDiff(face)"
            >
                {{ face.futureDiffCount }} campagne<span *ngIf="face.futureDiffCount != 1">s</span> à venir
            </button>
            <button mat-button *ngIf="face.seeFutureDiff" class="futureDiffButton" (click)="hideFutureDiff(face)">
                Masquer les campagnes à venir
            </button>
        </div>
    </mat-card>

</div>
